import { useMemo } from 'react'
import { formatColumnName } from '../../../helpers/functions'
import { Button, Column, DataTable as UiDataTable, Input, Toolbar } from '../../../ui'

export interface dataTableProps {
    data: any
    viewButtons?: true | false
    viewButtonText?: string
    viewBaseUrl?: string
    viewUrlColumn?: string
    exportButton?: true | false
    search?: true | false
    searchText?: string
    searchOnChange?: any
}

/**
 * Legacy auto-column table: infers columns from the first row's keys.
 * New code should use `DataTable` from `ui` with explicit `columns`.
 */
export const DataTable = (props: dataTableProps) => {
    const { data, viewButtons, viewButtonText, viewBaseUrl, viewUrlColumn, exportButton, search, searchText, searchOnChange } = props

    if (typeof data != 'object' || !data.length) {
        throw new Error('type of data is not an array.')
    }

    const columns = useMemo<Column<any>[]>(() => {
        const keys = Object.keys(data[0])
        const cols: Column<any>[] = keys.map((key) => ({ key, header: formatColumnName(key), render: (row) => row[key] }))
        if (viewButtons && viewBaseUrl) {
            cols.unshift({
                key: '__view',
                header: '',
                width: 90,
                render: (row) => (
                    <Button as="a" size="sm" href={viewUrlColumn ? `${viewBaseUrl}${row[viewUrlColumn]}` : viewBaseUrl}>
                        {viewButtonText ?? 'View'}
                    </Button>
                ),
            })
        }
        return cols
    }, [data, viewButtons, viewBaseUrl, viewUrlColumn, viewButtonText])

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {search && (
                <Toolbar end={exportButton ? <Button>Export</Button> : undefined}>
                    <Input type="search" placeholder={searchText ?? 'Search...'} onChange={searchOnChange} style={{ minWidth: 260 }} />
                </Toolbar>
            )}
            <UiDataTable columns={columns} rows={data} rowKey={(_, i) => i} />
        </div>
    )
}
